// extracted by mini-css-extract-plugin
export default {"NotificationMessage":"NotificationMessage_NotificationMessage__A7oGE","fadeOut":"NotificationMessage_fadeOut__h8pFX"};